import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import ErrorNotice from "../errors/ErrorNotice";
import { HOME_PATH } from "../shared/routing/appPaths";

/** Any path that is not a route of the app. */
export default function NotFoundPage() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="max-w-2xl space-y-4 p-4">
      <ErrorNotice error={{ kind: "invalidAddress", address: location.pathname }} />
      <Link to={HOME_PATH} className="app-link text-sm underline">
        {t("app.toHome")}
      </Link>
    </div>
  );
}
